import React from "react";
import PropTypes from "prop-types";
import { Grid, Container } from "@mui/material";
import "@fortawesome/fontawesome-free/css/all.css";
import styles from "./index.module.scss";
import useHomePageFiles from "../../utils/useHomePageFiles";

function Template({ data }) {
  const { title, subtitle, seeMoreLink, stories } = data;

  return (
    <div className={styles.wrapper}>
      <Container maxWidth="xl">
        <h2 className={styles.title}>{title}</h2>
        <p className={styles.subtitle}>{subtitle}</p>
        <Grid container className={styles.storiesWrapper}>
          {stories.map((userStoryHomePage) => {
            const image = userStoryHomePage?.userStory?.image?.url;
            const overrideImage = useHomePageFiles(userStoryHomePage.image);
            return (
              <Grid
                item
                xs={12}
                className={styles.story}
                key={userStoryHomePage.userStory.name}
              >
                <div className={styles.leftCol}>
                  <img
                    src={overrideImage || image}
                    alt={userStoryHomePage.userStory.name}
                  />
                </div>
                <div className={styles.rightCol}>
                  <h2 className={styles.title}>
                    {userStoryHomePage?.userStory?.name}
                  </h2>
                  <p
                    className={styles.overview}
                    dangerouslySetInnerHTML={{
                      __html: userStoryHomePage?.userStory?.description
                    }}
                  />
                  <a
                    className={styles.cta}
                    href={userStoryHomePage?.userStory?.link}
                  >
                    {userStoryHomePage?.buttonText || "read more"}
                  </a>
                </div>
              </Grid>
            );
          })}
        </Grid>
        <div className={styles.link}>
          <a href={seeMoreLink}>
            SEE MORE CASE STUDIES
            <i className="fa fa-arrow-right" />
          </a>
        </div>
      </Container>
    </div>
  );
}

Template.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string,
    subtitle: PropTypes.string,
    seeMoreLink: PropTypes.string,
    stories: PropTypes.arrayOf(
      PropTypes.shape({
        buttonText: PropTypes.string,
        image: PropTypes.string,
        userStory: PropTypes.shape({
          name: PropTypes.string,
          description: PropTypes.string,
          link: PropTypes.string,
          image: PropTypes.shape({
            url: PropTypes.string
          })
        })
      })
    )
  }).isRequired
};

export default Template;
